import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import clsx from 'clsx';

class SideBar extends Component {
  closeNav() {
    var closemyslide = document.getElementById('mySidenav');
    if (closemyslide) closemyslide.classList.remove('open-side');
  }

  handleSubmenu = (event) => {
    if (event.target.classList.contains('sub-arrow')) return;

    if (event.target.nextElementSibling.classList.contains('opensub1'))
      event.target.nextElementSibling.classList.remove('opensub1');
    else {
      document.querySelectorAll('.opensub1').forEach(function (value) {
        value.classList.remove('opensub1');
      });
      event.target.nextElementSibling.classList.add('opensub1');
    }
  };

  handleSubTwoMenu = (event) => {
    if (event.target.classList.contains('sub-arrow')) return;

    if (event.target.nextElementSibling.classList.contains('opensub2'))
      event.target.nextElementSibling.classList.remove('opensub2');
    else {
      document.querySelectorAll('.opensub2').forEach(function (value) {
        value.classList.remove('opensub2');
      });
      event.target.nextElementSibling.classList.add('opensub2');
    }
  };

  handleSubThreeMenu = (event) => {
    if (event.target.classList.contains('sub-arrow')) return;

    if (event.target.nextElementSibling.classList.contains('opensub3'))
      event.target.nextElementSibling.classList.remove('opensub3');
    else {
      document.querySelectorAll('.opensub3').forEach(function (value) {
        value.classList.remove('opensub3');
      });
      event.target.nextElementSibling.classList.add('opensub3');
    }
  };

  handleSubFourMenu = (event) => {
    if (event.target.classList.contains('sub-arrow')) return;

    if (event.target.nextElementSibling.classList.contains('opensub4'))
      event.target.nextElementSibling.classList.remove('opensub4');
    else {
      document.querySelectorAll('.opensub4').forEach(function (value) {
        value.classList.remove('opensub4');
      });
      event.target.nextElementSibling.classList.add('opensub4');
    }
  };

  handleMegaSubmenu = (event) => {
    if (event.target.classList.contains('sub-arrow')) return;

    if (event.target.nextElementSibling.classList.contains('opensidesubmenu'))
      event.target.nextElementSibling.classList.remove('opensidesubmenu');
    else {
      event.target.nextElementSibling.classList.add('opensidesubmenu');
    }
  };

  render() {
    const {
      match: {
        params: { role },
      },
      location: { pathname },
    } = this.props;
    return (
      <div id='mySidenav' className='sidenav'>
        <a
          href='javascript:void(0)'
          className='sidebar-overlay'
          onClick={this.closeNav}
        />
        <nav>
          <a onClick={this.closeNav}>
            <div className='sidebar-back text-left'>
              <i className='fa fa-angle-left pr-2' aria-hidden='true' /> Back
            </div>
          </a>
          <ul id='sub-menu' className='sidebar-menu' onClick={this.closeNav}>
            {role === 'member' && (
              <>
                <li
                  className={clsx({
                    // active: pathname.includes('account-history'),
                    active: pathname.includes("earning"),
                  })}
                >
                  <Link
                    // to={`${process.env.PUBLIC_URL}/dashboard/${role}/account-history`}
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/earning`}
                  >
                    {/* View My Account History */}
                    My Earnings
                  </Link>
                </li>

                <li
                  className={clsx({
                    active: pathname.includes('account'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/account`}
                  >
                    View My Eksplode code
                  </Link>
                </li>

                <li
                  className={clsx({
                    active: pathname.includes('products'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/products`}
                  >
                    View My EACs
                  </Link>
                </li>

                <li
                  className={clsx({
                    active: pathname.includes('my-contacts'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/my-contacts`}
                  >
                    View My Contact List
                  </Link>
                </li>

                <li
                  className={clsx({
                    active: pathname.includes('availableeac'),
                  })}
                >
                  <Link to={`${process.env.PUBLIC_URL}/availableeac`}>
                    View Available EACs
                  </Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('greeting'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/greeting`}
                  >
                    Customize My EAC Greeting
                  </Link>
                </li>
              </>
            )}
            {role === 'merchant' && (
              <>
                <li
                  className={clsx({
                    active: pathname.includes('/dashboard/merchant'),
                  })}
                >
                  <Link to={`${process.env.PUBLIC_URL}/dashboard/merchant`}>
                    My Account
                  </Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('shop'),
                  })}
                >
                  <Link to={`${process.env.PUBLIC_URL}/shop`}>My Products</Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('create-product'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/create-product`}
                  >
                    Create Product
                  </Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('add-charges'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/add-charges`}
                  >
                    Delivery Charges
                  </Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('earning'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/earning`}
                  >
                    My Earnings
                  </Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('orders'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/orders`}
                  >
                    My Orders
                  </Link>
                </li>
              </>
            )}

            {role === 'customer' && (
              <>
                <li
                  className={clsx({
                    active: pathname.includes(`/dashboard/${role}`),
                  })}
                >
                  <Link to={`${process.env.PUBLIC_URL}/dashboard/${role}`}>
                    My Account
                  </Link>
                </li>
                <li
                  className={clsx({
                    active: pathname.includes('order'),
                  })}
                >
                  <Link
                    to={`${process.env.PUBLIC_URL}/dashboard/${role}/order`}
                  >
                    My Orders
                  </Link>
                </li>
              </>
            )}
            {(role === 'member' || role === 'merchant') && (
              <li
                className={clsx({
                  active: pathname.includes('payment-method'),
                })}
              >
                {/* <Link to={`${process.env.PUBLIC_URL}/dashboard/${role}/payment-method`}>
                  Change Method of Receiving Cash
                </Link> */}
                <Link to={`${process.env.PUBLIC_URL}/account-list`}>
                  Manage Accounts
                </Link>
              </li>
            )}
            <li
              className={clsx({
                active: pathname.includes('change-password'),
              })}
            >
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard/${role}/change-password`}
              >
                Change Password
              </Link>
            </li>
            <li
              className={`${clsx({
                active: pathname.includes('change-my'),
              })}`}
            >
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard/${role}/change-my`}
              >
                Change Account Details
              </Link>
            </li>
            <li className='last'>
              <Link to='#'>Log Out</Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default withRouter(SideBar);
